/**
 * 带 ⭐️ 是用来记录后台的记录为空白的情况，前端赋予的一个值，达到前后台一致的目的
 */

export var WordMimeTypes = [
/**
 * (.doc | .dot）微软 Office Word 格式（Microsoft Word 97 - 2004 document）
 */
'application/msword',
/**
 * (.docx) 微软 Office Word 文档格式
 */
'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
/**
 *  (.wps) 金山 Office 文字排版文件格式
 */
'application/kswps',
/**
 * (.wpt) 金山 Office 文字排版文件格式模板
 */
'application/kswpt',
/**
 * (.dotx) 微软 Office Word 文档格式模板
 */
'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
/**
 * (.docm) Microsoft Word macro-enabled document
 */
'application/vnd.ms-word.document.macroEnabled.12',
/**
 * (.dotm) Microsoft Word macro-enabled document template
 */
'application/vnd.ms-word.template.macroEnabled.12'];
export var ExcelMimeTypes = [
/**
 * (.xls .xlm .xla .xlc .xlt .xlw) 微软 Office Excel 格式（Microsoft Excel 97 - 2004 Workbook
 */
'application/vnd.ms-excel',
/**
 * (.xlsx) 微软 Office Excel 文档格式
 */
'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
/**
 * (.xltx) 微软 Office Excel 文档格式模板
 */
'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
/*
 * (.csv) CSV 文件
 */
'text/csv', 'text/csv; charset=utf-8',
/**
 * (.xlsb) An XLSB file is a spreadsheet workbook created by Microsoft Excel
 */
'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
/**
 * (.xlsm) An XLSM file is a macro-enabled spreadsheet created by Microsoft Excel
 */
'application/vnd.ms-excel.sheet.macroEnabled.12',
/**
 * (.xltm) An XLTM file is a macro-enabled spreadsheet template created by Microsoft Excel
 */
'application/vnd.ms-excel.template.macroEnabled.12',
/**
 * (.et) 金山 Office 表格文件格式
 */
'application/kset',
/**
 * (.ett) 金山 Office 表格文件格式模板
 */
'application/ksett'];
export var PowerPointMimeTypes = [
/**
 * (.pptx) 微软 Office PowerPoint 文稿格式
 */
'application/vnd.openxmlformats-officedocument.presentationml.presentation',
/**
 * (.ppt .pps .pot) 微软 Office PowerPoint 格式（Microsoft PowerPoint 97 - 2003 演示文稿
 */
'application/vnd.ms-powerpoint',
/**
 * (.potx) Microsoft PowerPoint template
 */
'application/vnd.openxmlformats-officedocument.presentationml.template',
/**
 * (.ppsx) Microsoft PowerPoint slideshow
 */
'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
/**
 * (.dps) 金山 Office 演示文稿格式
 */
'application/ksdps',
/**
 * (.dpt) 金山 Office 演示文稿格式模板
 */
'application/ksdpt',
/**
 * (.pptm) A PPTM file is a macro-enabled presentation created by Microsoft PowerPoint
 */
'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
/**
 * (.potm) A POTM file is a macro-enabled presentation template created by Microsoft PowerPoint
 */
'application/vnd.ms-powerpoint.template.macroEnabled.12',
/**
 * (.ppsm) A PPSM file is a macro-enabled slide show created by Microsoft PowerPoint
 */
'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'];
export var TextMimeTypes = [
/**
 * (.lrc) 音乐歌词文件 ⭐️
 */
'text/lrc',
/**
 * (.asp) asp 程序文件
 */
'text/asp; charset=utf-8',
/**
 * (.bat .cmd .btm) ⭐️
 */
'application/x-msdownload',
/**
 * (.rtf) Rich Text Format file  ⭐️
 */
'text/richtext; charset=utf-8',
/**
 * (.bas, .txt, .log) BASIC Source Code
 */
'text/plain', 'text/plain; charset=utf-8',
/**
 * .xml
 */
'text/xml',
/**
 * (.htm, .html)
 */
'text/html', 'text/html; charset=utf-8',
/**
 * (.md)
 */
'text/markdown'];
export var CodeMimeTypes = [
/**
 * (.c) ⭐️
 */
'text/x-c; charset=utf-8',
/**
 * (.cpp) ⭐️
 */
'text/x-c; charset=utf-8',
/**
 * (.h) ⭐️
 */
'text/x-chdr',
/**
 * (.asm , .s) ⭐️
 */
'text/x-asm; charset=utf-8',
/**
 * (.java) ⭐️
 */
'text/x-java-source; charset=utf-8',
/**
 * (.js, .jsx ,.ts ,.tsx) ⭐️
 */
'text/javascript',
/**
 * (.go)
 */
'text/x-go'];
export var ImageMimeTypes = [
/**
 * (.raw) ⭐️
 * https://stackoverflow.com/questions/43473056/which-mime-type-should-be-used-for-a-raw-image#:~:text=GNOME%20RAW%20Thumbnailer%20project%2C%20the,image%2Fx%2Dsony%2Darw
 */
'image/x-sony-arw',
/**
 * (.bmp)
 */
'image/bmp',
/**
 * (.pcx)
 */
'image/vnd.zbrush.pcx', 'image/x-pcx',
/**
 * (.image/tiff)
 */
'image/tiff',
/**
 * (.gif)
 */
'image/gif',
/**
 * (.exif) ⭐️
 */
'image/x-exif',
/**
 *  (.jpeg jpg)
 */
'image/jpeg',
/**
 *  (.fpx)
 * https://www.fileformat.info/info/mimetype/image/vnd.fpx/index.htm
 */
'image/vnd.fpx',
/**
 * (.svg)
 */
'image/svg+xml',
/**
 * (.psd)
 */
'image/vnd.adobe.photoshop',
/**
 * (.cdr) ⭐️
 */
'image/x-cdr',
/** *
 * (.pcd) ⭐️
 */
'image/x-photo-cd',
/**
 * (.dxf)
 */
'image/vnd.dxf',
/**
 * (.ufo) ⭐️
 * https://fileinfo.com/extension/ufo
 */
'image/x-ufo',
/** *
 * .eps
 */
'application/postscript',
/**
 * (.png)
 */
'image/png',
/**
 * (.wmf)
 */
'image/wmf',
/**
 * (.webp)
 */
'image/webp',
/**
 * (.tga)
 */
'image/x-tga'];
export var AudioMimeTypes = [
/**
 * (.mp3,.mpeg)
 */
'audio/mpeg',
/**
 * (.acc)
 */
'audio/aac',
/**
 * (.flac)
 */
'audio/x-flac',
/**
 * (.amr)
 */
'audio/amr', 'audio/AMR',
/**
 * (m4a, m4b)
 * https://stackoverflow.com/a/39898145
 */
'audio/mp4',
/**
 * (.wma)
 */
'audio/x-ms-wma',
/**
 * (.wav)
 */
'audio/x-wav',
/**
 * (.cd) ⭐️
 */
'audio/x-cd',
/**
 * (.wave) ⭐️
 */
'audio/x-wave',
/**
 * (.aiff)
 */
'audio/x-aiff',
/**
 * (.midi)
 */
'audio/midi',
/**
 * (.ra)
 */
'audio/x-realaudio',
/**
 * (.vqf)
 * https://en.wikipedia.org/wiki/TwinVQ
 */
'audio/x-twinvq',
/**
 * (.ogg)
 */
'audio/ogg',
/**
 * (.ape) ⭐️
 * http://www.wikidata.org/entity/Q1064017
 */
'audio/x-ape',
/**
 * (.weba) ⭐️
 * https://fileinfo.com/extension/weba
 */
'audio/webm',
/**
 * (mpeg-4)
 */
'audio/mpeg-4'];
export var VideoMimeTypes = [
/**
 * (.mp4) ⭐️
 * (.m4v https://stackoverflow.com/a/15279480)
 */
'video/mp4',
/**
 * (.3gp)
 */
'video/3gpp',
/**
 * (.asf, .asx) ⭐️
 */
'video/x-ms-asf',
/**
 * (.avi)
 */
'video/x-msvideo',
/**
 * (.dv)
 */
'video/dv',
/**
 * (.flv)
 */
'video/x-flv',
/**
 * (.f4v) ⭐️
 */
'video/x-f4v',
/**
 * (.m3u8)
 */
'application/vnd.apple.mpegurl',
/**
 * (.mkv)
 */
'video/x-matroska',
/**
 * (.qt , .mov)
 */
'video/quicktime',
/**
 * (.mpg, .mpeg)
 */
'video/mpeg',
/**
 * (.mts https://en.wikipedia.org/wiki/.m2ts)
 */
'video/mp2t',
/**
 * (.rmvb)
 */
'application/vnd.rn-realmedia',
/**
 * (.rm)
 */
'audio/x-pn-realaudio',
/**
 * (.wmv)
 */
'video/x-ms-wmv',
/**
 * (.dat)
 */
'video/dat'];
export var archiveMimeTypes = [
/**
 * (.zip)
 */
'application/zip',
/**
 * (.rar)
 */
'application/vnd.rar',
/**
 * （.z）
 */
'application/x-compress'];
export var flowChatMimeTypes = ['application/vnd.ms-visio.drawing', 'application/x-visio', 'application/vnd.ms-visio.drawing.main+xml'];
export var mindMimeTypes = ['application/vnd.pos'];
//# sourceMappingURL=enumerate.js.map